import { status } from '@/alas';
import { Self } from '@/vue-core';
import { defineComponent, ref, computed, onMounted } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let self = new Self(context);
        // ================
        //
        // refs
        //
        let farm = ref(status.fetch('farm'));
        let types = ref(status.fetch('types'));
        let cycles = ref(status.fetch('cycles'));
        // ================
        //
        // computed
        //
        let toCreateCycle = computed(() => {
            return {
                name: 'farms.cycles.create',
                params: {
                    id: self.route.params.id
                }
            };
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            cycles.value.o.fetch.start({
                farmId: self.route.params.id
            });
        });
        // ================
        //
        // methods
        //
        let getTitleName = (cycle) => {
            return types.value.fetch(cycle.type).name + ' - ' + types.value.m.getBreed(cycle.type, cycle.breed).name;
        };
        let getDate = (cycle) => {
            let output = '';
            if (cycle.$v.closed) {
                output = cycle.$v.createdAt + ' - ' + cycle.$v.finishedAt;
            }
            else {
                output = cycle.$v.createdAt;
            }
            return output + ' - ' + self.t('共') + cycle.$v.days + self.t('天');
        };
        let toCreateProfile = (createdTime) => {
            return {
                name: 'farms.cycles.overview',
                params: {
                    id: self.route.params.id,
                    cycle: createdTime
                }
            };
        };
        // ================
        //
        // done
        //
        return {
            farm,
            types,
            cycles,
            toCreateCycle,
            getTitleName,
            getDate,
            toCreateProfile
        };
    }
});
